var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BillingSummary',{staticClass:"mt-8",attrs:{"last-billed":_vm.lastBilled,"next-invoice":_vm.nextInvoice}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }